<div
  class="field-wrapper"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxFlex="100%"
  [formGroup]="form"
 
>
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <mat-form-field fxFlex [class.readonly]="readonly" floatLabel="always">
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <span matPrefix *ngIf="prefix" [innerHTML]="prefix"></span>
    <input
      *ngIf="controlName && !isRequired"
      matInput
    
      [type]="type"
      [formControlName]="controlName"
      [readonly]="readonly"
      [placeholder]="placeholder || label"
    />
    <!-- Need it this way for screen readers D: -->
    <input
      *ngIf="controlName && isRequired"
      matInput
    
      [type]="type"
      [formControlName]="controlName"
      [readonly]="readonly"
      [placeholder]="placeholder || label"
      required
    />
    <input
      *ngIf="!controlName"
      matInput
    
      [(ngModel)]="value"
      [ngModelOptions]="{ standalone: true }"
      [type]="type"
      (keyup.backspace)="empty()"
      (keydown.enter)="submit()"
      (keydown)="changes()"
      [placeholder]="placeholder || label"
    />
    <span matSuffix *ngIf="suffix" [innerHTML]="suffix"></span>
    <mat-hint
      align="start"
      *ngIf="hintStart"
      [innerHTML]="hintStart"
    ></mat-hint>
    <mat-hint align="end" *ngIf="hintEnd" [innerHTML]="hintEnd"></mat-hint>
    <mat-error *ngIf="controlName && errors(control)">
      <mat-icon>error</mat-icon>
      {{ errors(control) }}
    </mat-error>
  </mat-form-field>
</div>
